/** Client helpers for global unique project names. */

export function buildProjectNameCandidates(baseName, maxSuffix = 20) {
  const base = String(baseName ?? '').trim();
  if (!base) return [];
  const out = [base];
  for (let i = 2; i <= maxSuffix + 1; i += 1) {
    out.push(`${base} ${i}`);
  }
  return out;
}

export function parseProjectNameTakenError(err) {
  const data = err?.response?.data;
  const nested = data?.message;
  if (Array.isArray(data?.suggestions)) {
    return data.suggestions.filter((s) => typeof s === 'string');
  }
  if (typeof nested === 'object' && nested !== null && Array.isArray(nested.suggestions)) {
    return nested.suggestions.filter((s) => typeof s === 'string');
  }
  return [];
}

export function projectNameTakenMessage(err, fallback) {
  const data = err?.response?.data;
  const msg = data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg !== null && typeof msg.message === 'string') {
    return msg.message;
  }
  return fallback;
}
